import {semiDarkGray} from '@modifi/colors'
import {Caption, H4, media} from '@modifi/ui'
import styled, {FlattenSimpleInterpolation, css} from 'styled-components'

import {colorMap} from '../common'

type WrapperType = {
  backgroundColor?: string
  textAlign?: string
}

export const Wrapper = styled.div<WrapperType>`
  ${({backgroundColor}): FlattenSimpleInterpolation | string =>
    backgroundColor && colorMap?.[backgroundColor]
      ? css`
          background-color: ${colorMap?.[backgroundColor]};
        `
      : ''}
  margin-bottom: -8px;

  > * {
    text-align: ${({textAlign}): string => textAlign || 'center'};
  }
`

export const CaptionLight = styled(Caption)`
  color: ${semiDarkGray};
`

export const StyledH4 = styled(H4)`
  font-size: 24px;
  ${media.min.lg`
    font-size: 32px;
  `}
`
